"use client";

/**
 * MODAL — `<dialog>` NATIVO, aberto por `showModal()`.
 *
 * ESTE DESENHO NAO E NOVO NO REPO: e o mesmo de `(interno)/exames/page.tsx`,
 * onde o dialogo de Filtros ja pagou as quatro armadilhas que o `<dialog>`
 * cobra. Este arquivo existe para o segundo modal nao reimplementa-las — e a
 * primeira versao dele, escrita com `createPortal` + `role="dialog"`, ja tinha
 * nascido com um bug que o nativo nao deixa acontecer (ver ESCAPE abaixo).
 *
 * O QUE O NATIVO ENTREGA DE GRACA, e que uma div com `position: fixed` obriga a
 * reescrever: foco preso dentro do dialogo, Escape, resto da pagina inerte,
 * `::backdrop` de verdade e top layer (nenhum `z-index` de ancestral o cobre).
 *
 * A DEVOLUCAO DO FOCO A QUEM ABRIU o nativo so faz no `close()` — e aqui so o
 * Escape passa por ele. O botao Fechar, o clique no fundo e o rodape de quem
 * usa o modal chamam `aoFechar`, o pai desmonta, e tirar o `<dialog>` do DOM
 * nao roda os passos do `close()`: o foco caia no `<body>`, e quem navega por
 * teclado voltava ao topo de uma tabela de 17 linhas (o "?" do custo, em
 * Processamento). Por isso o modal guarda quem tinha o foco ao abrir e o
 * devolve ele mesmo ao sair do DOM — ver QUEM ABRIU, no efeito.
 *
 * ESCAPE — a razao de existir desta versao. Na primeira, o Escape era um
 * `onKeyDown` do React no `<div>` portalizado. Ele so disparava com o foco
 * DENTRO do modal: bastava clicar numa area nao-focavel (o corpo, uma tabela)
 * para o `activeElement` voltar ao `<body>` — que e PAI do no portalizado — e a
 * tecla nunca mais entrava no caminho React do portal. O botao seguia escrito
 * "Fechar (Esc)" e o Esc nao fechava nada. Com `showModal()` quem trata o Escape
 * e o navegador, e `onClose` so sincroniza o estado.
 *
 * AS QUATRO ARMADILHAS, herdadas do dialogo de Filtros:
 *
 *  1. `onClose` e OBRIGATORIO. O Escape fecha o `<dialog>` por conta do
 *     navegador, sem passar por handler nenhum. Sem sincronizar, o React segue
 *     achando que o modal esta aberto e o proximo clique no botao nao reabre.
 *  2. BACKDROP ancorado no `mousedown`. O alvo de um `click` e o ancestral comum
 *     do mousedown e do mouseup: apertar o botao dentro do cartao, arrastar e
 *     soltar sobre o fundo faria o alvo subir ate o `<dialog>` e descartaria o
 *     rascunho por um gesto que comecou dentro.
 *  3. `m-auto`. O preflight do Tailwind zera a margin de todo elemento, e e
 *     justamente a margin auto do user agent que centraliza o `<dialog>` modal.
 *     Sem ela o cartao cola no canto superior esquerdo.
 *  4. A ROLAGEM FICA NO FILHO. Com `overflow-auto` no proprio `<dialog>`, um
 *     clique na barra de rolagem tem o dialogo como alvo e cai no ramo de
 *     descarte — arrastar a barra apagaria o rascunho.
 *  5. `onClose` SO REAGE AO PROPRIO DIALOGO (26/09). O `close` nativo nao
 *     borbulha, mas o React o entrega tambem aos ancestrais (o mesmo que faz
 *     com `load`): um Modal aberto por cima de outro (o "Ensinar a IA" sobre a
 *     analise de infracoes) fechava os dois no Escape. O empilhamento em si e
 *     do navegador: o segundo `showModal()` vai para o topo do top layer, o
 *     Escape e o clique no fundo fecham so o de cima, e o de baixo fica inerte.
 *
 * O `<dialog>` AQUI E O CARTAO, nao a area cheia: e `p-0` com um unico filho que
 * o preenche, entao nenhuma superficie dele fica exposta a um clique que nao
 * seja no backdrop. Quem quiser "corrigir" o tamanho para 100vw fara todo
 * clique dentro fechar o modal.
 *
 * TAMANHOS: "70" (o padrao), "80" (a constatacao do kanban, 04/10/2026) e "90"
 * (o trecho da camera, o custo e, desde 26/09, a analise de infracoes — que
 * passou 25/09 em 80, ate o dono pedir 90). Os tres so mudam a largura e a
 * altura do CARTAO — o <dialog> continua sendo o cartao, com um filho so.
 * "confirmacao" (05/10/2026, o "Rodar tudo" que saiu do `window.confirm`): a
 * largura de leitura de um texto (40rem) e a ALTURA DO CONTEUDO, com teto. O
 * teto mora no filho, e nao no <dialog>: o filho de altura `h-full` num pai de
 * altura automatica nao tem altura, e a rolagem do miolo nunca ligaria. Com o
 * `max-h` nele, a coluna flex encolhe o miolo (`min-h-0`) e so ele rola.
 * "cheia" (11/10/2026, a analise completa do exame, no molde da sala de
 * auditoria do legado): a tela inteira, sem borda nem canto. `h-full w-full`
 * e nao `100vw`: o <dialog> modal e `position: fixed`, entao 100% e a janela SEM
 * a barra de rolagem da pagina de tras — `100vw` a inclui e empurraria o
 * "Fechar" para fora. `max-*-none` desfaz o teto do user agent
 * (`calc(100% - 2em - 6px)`), que deixaria a moldura de 1em que a tela cheia
 * existe para tirar. Sem backdrop exposto, o clique no fundo nao existe: Esc e
 * o botao Fechar fecham.
 *
 * LIMITE CONHECIDO: em tela estreita o cartao vale 95vw x 92vh e sobra uma tira
 * de poucos pixels de backdrop. Fechar por clique no fundo fica impraticavel ali
 * — Escape e o botao Fechar continuam valendo, e sao os caminhos que importam
 * no celular.
 */

import { useEffect, useEffectEvent, useId, useRef } from "react";

/**
 * As classes de cada tamanho, LITERAIS: o Tailwind so gera a classe que
 * aparece escrita no fonte, e montar `sm:w-[${n}vw]` em tempo de execucao
 * daria um cartao sem largura.
 */
const CLASSE_DO_TAMANHO = {
  "70": "h-[92svh] w-[95vw] sm:h-[70svh] sm:w-[70vw]",
  "80": "h-[94svh] w-[96vw] sm:h-[80svh] sm:w-[80vw]",
  "90": "h-[95svh] w-[97vw] sm:h-[90svh] sm:w-[90vw]",
  confirmacao: "w-[95vw] sm:w-[40rem]",
  cheia: "h-full max-h-none w-full max-w-none",
} as const;

/** A borda e o canto do cartao. A tela cheia nao tem nenhum dos dois: e a janela. */
const MOLDURA = "rounded-xl border border-app-border";

/** O filho unico do cartao: ocupa a altura fixa, ou (na confirmacao) a do conteudo, com teto. */
const CLASSE_DO_FILHO: Partial<Record<keyof typeof CLASSE_DO_TAMANHO, string>> = {
  confirmacao: "flex max-h-[92svh] flex-col sm:max-h-[85svh]",
};

export function Modal({
  titulo,
  descricao,
  aoFechar,
  tamanho = "70",
  barra,
  acoesDoCabecalho,
  acoes,
  aoCancelar,
  devolverFocoA,
  children,
}: {
  titulo: string;
  /** Linha de apoio sob o titulo. Opcional — nem todo modal precisa explicar-se. */
  descricao?: React.ReactNode;
  aoFechar: () => void;
  tamanho?: keyof typeof CLASSE_DO_TAMANHO;
  /**
   * Faixa FIXA entre o cabecalho e o conteudo — a navegacao do modal.
   *
   * Separada de `children` porque ela NAO pode rolar junto: numa tela de
   * configuracao com tabela longa, a tira de abas subir para fora da vista
   * deixa a pessoa sem saber em que secao esta nem como sair dela.
   */
  barra?: React.ReactNode;
  /**
   * Botoes do CABECALHO, a direita, antes do "Fechar" (11/10/2026: o "✎ N
   * ensinamentos" da analise completa do exame, no lugar onde o legado o tem).
   * Sem eles o cabecalho e o de sempre.
   */
  acoesDoCabecalho?: React.ReactNode;
  /** Botoes do rodape. Sem eles o rodape nao e desenhado. */
  acoes?: React.ReactNode;
  /**
   * O Escape (o `cancel` do `<dialog>`) antes de fechar: devolver `true` =
   * "tratei aqui, NAO feche". Existe para o painel sobre a lista da analise de
   * infracoes (26/09/2026, noite): com ele aberto, Esc fecha so o painel, e o
   * video e a lista continuam onde estavam. Sem o prop, nada muda.
   *
   * Vale a armadilha 5 tambem aqui: o `cancel` nao borbulha, mas o React o
   * entrega aos ancestrais — o Esc no "Ensinar a IA" aberto por cima chegaria
   * a este handler. So o proprio `cancel` conta.
   *
   * O `cancel` SOZINHO NAO BASTA — medido no Chromium headless em 26/09/2026:
   * o Chrome so deixa `preventDefault()` segurar o `cancel` se houve ativacao
   * do usuario desde o ultimo cancel segurado (a trava contra "dialogo que nao
   * fecha"), e um painel aberto pelo TECLADO (Enter no botao) depois de um Esc
   * ja segurado chegava com `cancelable: false` — o Esc fechava o modal
   * inteiro. O que funcionou em todos os casos: segurar o proprio `keydown`
   * do Escape, em CAPTURA no documento (com o foco no `<body>` ou no proprio
   * `<dialog>`, depois de um clique em area nao focavel, o evento nao passa
   * por filho nenhum). Keydown cancelado = nao ha pedido de fechar, nem
   * `cancel`. O `onCancel` fica como segunda linha (outros pedidos de fechar
   * que nao sao tecla).
   */
  aoCancelar?: () => boolean;
  /**
   * Quem recebe o foco de volta ao fechar, quando nao e o `activeElement` da
   * abertura (05/10/2026): o botao que abre o modal depois de um `await` fica
   * `disabled` durante a leitura, o Chromium tira o foco de botao desabilitado,
   * e o modal abria com o foco no `<body>` — Cancelar e Esc o deixavam la. Lido
   * so na montagem.
   */
  devolverFocoA?: HTMLElement | null;
  children: React.ReactNode;
}) {
  const idTitulo = useId();
  const dialogo = useRef<HTMLDialogElement>(null);
  const gestoComecouNoBackdrop = useRef(false);
  const quemAbriu = useRef<HTMLElement | null>(null);
  const origem = useRef(devolverFocoA ?? null);

  // O `aoCancelar` do render atual, lido pelo ouvinte do documento sem
  // re-registra-lo a cada render.
  const cancelar = useEffectEvent(() => aoCancelar?.() === true);
  const temCancelar = aoCancelar !== undefined;

  // ESC SEGURADO NO KEYDOWN — ver `aoCancelar`. So quando o modal tem quem
  // cancele, e so com ELE no topo: um `<dialog>` modal aberto dentro dele (o
  // "Ensinar a IA" por cima da analise) ou um alvo dentro de outro dialogo
  // recebem o Esc como sempre, e fecham so a si mesmos.
  useEffect(() => {
    const el = dialogo.current;
    if (el === null || !temCancelar) return;
    function aoTeclar(evento: KeyboardEvent) {
      if (evento.key !== "Escape" || evento.defaultPrevented || evento.isComposing) return;
      if (el === null || !el.open) return;
      const alvo = evento.target;
      const dialogoDoAlvo = alvo instanceof Element ? alvo.closest("dialog") : null;
      if (dialogoDoAlvo !== null && dialogoDoAlvo !== el) return;
      if ([...el.querySelectorAll("dialog")].some((outro) => outro.matches(":modal"))) return;
      if (cancelar()) {
        evento.preventDefault();
        evento.stopPropagation();
      }
    }
    document.addEventListener("keydown", aoTeclar, true);
    return () => document.removeEventListener("keydown", aoTeclar, true);
  }, [temCancelar]);

  useEffect(() => {
    const el = dialogo.current;
    if (el === null) return;
    // `showModal()` e nao o atributo `open`: `<dialog open>` abre em modo
    // NAO-modal — sem backdrop, sem inertizar a pagina e sem prender o foco.
    // O guarda `!el.open` e obrigatorio: chamar showModal() num dialogo ja
    // aberto levanta InvalidStateError, e em desenvolvimento o efeito roda duas
    // vezes (StrictMode).
    if (!el.open) {
      // Lido ANTES do showModal(), que move o foco para dentro. Na segunda
      // passada do StrictMode o dialogo ja esta aberto e isto nao roda: o ref
      // guarda o de verdade, e nao o botao Fechar que ganhou o autoFocus.
      const ativo = document.activeElement;
      quemAbriu.current =
        origem.current ?? (ativo instanceof HTMLElement && ativo !== document.body ? ativo : null);
      el.showModal();
    }
    /*
      SEM LIMPEZA QUE CHAME close(), e isto custou uma rodada de depuracao.

      Este modal e renderizado condicionalmente ({aberto && <Modal/>}), entao
      fechar = desmontar, e remover um <dialog> do DOM ja o tira do top layer.
      Um `return () => el.close()` parece zelo e e uma armadilha: em
      desenvolvimento o React monta, DESMONTA e monta de novo (StrictMode), o
      close() da desmontagem dispara `onClose`, o `onClose` chama `aoFechar`, o
      pai poe o estado em false — e o modal sumia no mesmo instante em que
      aparecia, sem erro nenhum no console.

      QUEM ABRIU recebe o foco de volta na limpeza, e ela nao toca no dialogo:
        - so com o `<dialog>` FORA do DOM. A limpeza de efeito da desmontagem
          roda depois da remocao; a da desmontagem simulada do StrictMode, com
          ele ainda no lugar — e ali nao ha nada a devolver;
        - so com o foco PERDIDO (no `<body>`). Se o Escape passou pelo
          `close()`, o nativo ja devolveu; se o pai levou o foco a outro lugar
          de proposito, ele fica onde o pai pos;
        - `preventScroll`, como o nativo: devolver o foco nao rola a pagina;
        - quem abriu e saiu do DOM (a pagina mudou) nao recebe nada.
    */
    return () => {
      const alvo = quemAbriu.current;
      if (el.isConnected || alvo === null || !alvo.isConnected) return;
      const ativo = document.activeElement;
      if (ativo !== null && ativo !== document.body) return;
      alvo.focus({ preventScroll: true });
    };
  }, []);

  return (
    <dialog
      ref={dialogo}
      aria-labelledby={idTitulo}
      onClose={(evento) => {
        // SO O PROPRIO close (armadilha 5): o `close` nativo nao borbulha, mas
        // o React o propaga pela arvore de componentes como se borbulhasse
        // (como faz com `load`), e o Escape num modal aberto POR CIMA deste
        // fechava os dois — achado com o "Ensinar a IA" sobre a analise, 26/09.
        if (evento.target === dialogo.current) aoFechar();
      }}
      onCancel={(evento) => {
        if (evento.target === dialogo.current && aoCancelar?.() === true) evento.preventDefault();
      }}
      onMouseDown={(evento) => {
        gestoComecouNoBackdrop.current = evento.target === dialogo.current;
      }}
      onClick={(evento) => {
        if (gestoComecouNoBackdrop.current && evento.target === dialogo.current) {
          aoFechar();
        }
        gestoComecouNoBackdrop.current = false;
      }}
      className={`m-auto overflow-hidden bg-app-surface p-0 text-neutral-800 backdrop:bg-black/60 dark:text-neutral-100 ${tamanho === "cheia" ? "" : MOLDURA} ${CLASSE_DO_TAMANHO[tamanho]}`}
    >
      {/* UM filho, preenchendo o dialogo: nenhuma superficie do <dialog> fica
          exposta a clique que nao seja backdrop. Ver a nota do topo. */}
      <div className={CLASSE_DO_FILHO[tamanho] ?? "flex h-full flex-col"}>
        <header className="flex shrink-0 flex-wrap items-baseline gap-x-3 gap-y-1 border-b border-app-border px-4 py-3">
          <h2 id={idTitulo} className="text-sm font-semibold">
            {titulo}
          </h2>
          {descricao !== undefined && (
            <p className="min-w-0 text-xs text-neutral-500 dark:text-neutral-400">
              {descricao}
            </p>
          )}
          {acoesDoCabecalho !== undefined && (
            <div className="ms-auto flex flex-wrap items-center gap-2 self-center">{acoesDoCabecalho}</div>
          )}
          <button
            type="button"
            autoFocus
            onClick={aoFechar}
            className={`${acoesDoCabecalho === undefined ? "ms-auto" : ""} rounded-md border border-app-border px-2.5 py-1 text-xs font-medium transition hover:bg-black/5 focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:outline-none dark:hover:bg-white/10`}
          >
            Fechar (Esc)
          </button>
        </header>

        {barra !== undefined && <div className="shrink-0">{barra}</div>}

        {/* O UNICO trecho que rola — e a barra de rolagem pertence a ele, nao ao
            <dialog> (armadilha 4). Num modal de configuracao, perder o botao
            Salvar ao rolar e perder o modal. */}
        <div className="min-h-0 flex-1 overflow-auto">{children}</div>

        {acoes !== undefined && (
          <footer className="flex shrink-0 flex-wrap items-center justify-end gap-2 border-t border-app-border px-4 py-3">
            {acoes}
          </footer>
        )}
      </div>
    </dialog>
  );
}

/**
 * ABAS dentro de um componente (nao de rota).
 *
 * De rota o repo ja tem (a tira de /exame/[hash]); dentro de um componente nao
 * havia nenhuma. Aqui as abas NAO viram URL de proposito: o estado do modal e
 * efemero, e escrever "qual aba estava aberta" no historico do navegador
 * transformaria o botao Voltar em "fecha uma aba do modal" — que e a ultima
 * coisa que alguem espera dele.
 */
export function Abas<T extends string>({
  abas,
  atual,
  aoTrocar,
  rotulo,
  nivel = "interna",
}: {
  abas: ReadonlyArray<{ chave: T; rotulo: string }>;
  atual: T;
  aoTrocar: (chave: T) => void;
  rotulo: string;
  /**
   * Tres niveis, do maior para o menor (19/10/2026: Config. Gerais passou de
   * dois para tres — categoria, assunto, abas internas):
   *
   *  - `secao` = o subcabecalho, logo abaixo do titulo: as categorias de
   *    Config. Gerais. Maior, fundo proprio, a selecionada com uma barra sob o
   *    rotulo.
   *  - `assunto` = o nivel do meio, os assuntos DE uma categoria. Pilulas
   *    pequenas, a selecionada cheia na cor da marca: nem barra nem pasta, para
   *    nao se confundir com o nivel de cima nem com o de baixo.
   *  - `interna` = as abas DENTRO de um assunto: a aba de pasta classica, menor.
   *
   * Os niveis precisam se distinguir de longe, ou a pessoa nao sabe qual das
   * tiras acabou de clicar.
   */
  nivel?: "secao" | "assunto" | "interna";
}) {
  if (nivel === "assunto") {
    return (
      <div
        role="tablist"
        aria-label={rotulo}
        className="flex shrink-0 flex-wrap gap-1.5 border-b border-app-border px-4 py-2"
      >
        {abas.map((aba) => (
          <button
            key={aba.chave}
            type="button"
            role="tab"
            aria-selected={aba.chave === atual}
            onClick={() => aoTrocar(aba.chave)}
            className={`rounded-full border px-3 py-1 text-xs font-medium transition ${
              aba.chave === atual
                ? "border-brand-600 bg-brand-600 text-white dark:border-brand-300 dark:bg-brand-300 dark:text-brand-950"
                : "border-app-border text-neutral-600 hover:bg-black/5 dark:text-neutral-300 dark:hover:bg-white/10"
            }`}
          >
            {aba.rotulo}
          </button>
        ))}
      </div>
    );
  }

  if (nivel === "secao") {
    return (
      <div
        role="tablist"
        aria-label={rotulo}
        className="flex shrink-0 flex-wrap gap-1 border-b border-app-border bg-black/[0.02] px-4 dark:bg-white/[0.03]"
      >
        {abas.map((aba) => (
          <button
            key={aba.chave}
            type="button"
            role="tab"
            aria-selected={aba.chave === atual}
            onClick={() => aoTrocar(aba.chave)}
            className={`-mb-px border-b-2 px-3 py-2 text-sm font-medium transition ${
              aba.chave === atual
                ? "border-brand-500 text-brand-700 dark:text-brand-300"
                : "border-transparent text-neutral-500 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-100"
            }`}
          >
            {aba.rotulo}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      role="tablist"
      aria-label={rotulo}
      className="flex shrink-0 flex-wrap gap-1 border-b border-app-border px-4 pt-3"
    >
      {abas.map((aba) => (
        <button
          key={aba.chave}
          type="button"
          role="tab"
          aria-selected={aba.chave === atual}
          onClick={() => aoTrocar(aba.chave)}
          className={`-mb-px rounded-t-md border border-b-0 px-3 py-1.5 text-xs font-medium transition ${
            aba.chave === atual
              ? "border-app-border bg-app-surface text-brand-700 dark:text-brand-300"
              : "border-transparent text-neutral-500 hover:bg-black/5 dark:text-neutral-400 dark:hover:bg-white/10"
          }`}
        >
          {aba.rotulo}
        </button>
      ))}
    </div>
  );
}
